import RewardScreens from "../rewardScreens/rewardScreens";
import Utils from "../utils";
import SlideManager from "../utils/slide-manager";
import Analytics from "../analytics";
import QuizManager from "../quizes/quiz-manager";
import SlideNotes from "../slideNotes/slideNotes";
import * as Events from "../utils/events";
import resize from "../utils/resize";
import { requestFullScreen } from "../utils/resize";
import getTabIndex from "../utils/tab-index";
import AssetsBusy from "../assets/assets-busy";
import getFileSizeString from "../helpers/getFileSizeString";
import TransformModifiers from "../objects/transform-modifiers";
import icons from "./icons";
import SystemDefaults from "../system-defaults";

const controlObjects = [], domEventListeners = [], gEventListeners = [];
const allowBusySlides = Utils.queryParams.has("force_slide_change");
let resumedTimestamp = 0, pausedTimeStamp = 0, timeOnSlide = 0;
let playPauseEnabled = true;
const prevSlide = document.createElement('p');
const play = document.createElement('p');
let autoplayEnabled, goId, mediaIsPlaying, mediaFinished = false, slideFinished = false;
let nextSlide = document.createElement('p');
const autoSpeed = document.createElement('p')
const volume = document.createElement('p')
const subtitle = document.createElement('p')
const fullscreenCartoonUI = document.createElement('p')
let volumeValue = 1
let videoPlayBackRate = 1
let playbackRate = 1
let isShowSubtitles = false

const langMap = [{
    title: "English",
    img: "/images/audio-uk.png",
    key: "EN",
    audiokey: "audio",
    default: true
}, {
    title: "Hindi",
    img: "/images/audio-ind.png",
    key: "hi",
    audiokey: "audioInd",
}, {
    title: "Bengali",
    key: "bn",
    img: "/images/audio-uk.png",
    audiokey: "audio",
}, {
    title: "Marathi",
    key: "mr",
    img: "/images/audio-uk.png",
    audiokey: "audio",
}, {
    title: "Telugu",
    key: "te",
    img: "/images/audio-uk.png",
    audiokey: "audio",
}, {
    title: "Tamil",
    key: "ta",
    img: "/images/audio-uk.png",
    audiokey: "audio",
}, {
    title: "Gujarati",
    key: "gu",
    img: "/images/audio-uk.png",
    audiokey: "audio",
}, {
    title: "Kannada",
    key: "kn",
    img: "/images/audio-uk.png",
    audiokey: "audio",
}, {
    title: "Assamese",
    key: "as",
    img: "/images/audio-uk.png",
    audiokey: "audio",
}, {
    title: "Odia",
    key: "or",
    img: "/images/audio-uk.png",
    audiokey: "audio",
}, {
    title: "Punjabi",
    key: "pa",
    img: "/images/audio-uk.png",
    audiokey: "audio",
}, {
    title: "Malayalam",
    key: "ml",
    img: "/images/audio-uk.png",
    audiokey: "audio",
}, {
    title: "Portuguese",
    key: "pt",
    img: "/images/audio-uk.png",
    audiokey: "audio",
}, {
    title: "French",
    key: "fr",
    img: "/images/audio-uk.png",
    audiokey: "audio",
}, {
    title: "German",
    key: "de",
    img: "/images/audio-uk.png",
    audiokey: "audio",
}, {
    title: "Arabic",
    key: "ar",
    img: "/images/audio-uk.png",
    audiokey: "audio",
}];

function startTour() {
    if (!Q3.isTransitioning && Q3.editMode) QuizManager.initSlideQuiz(SlideManager.activeSlide);
    Analytics.start();
    QuizManager.answers = 0;
    if (!Q3.editMode) resize();
};

export function setNextPrevEnabled({ next, prev }) {
    let firstVisibleSlide = SlideManager.getFirstVisibleSlide();
    if (firstVisibleSlide === null) firstVisibleSlide = 0;
    const slideQuiz = SlideManager.currentSlide.slideQuiz
    let slideQuizActive = slideQuiz && slideQuiz.active && !slideQuiz.isSubmitted && !slideQuiz.isInteractive;
    nextSlide.classList[(slideQuizActive ? false : next) ? "remove" : "add"]("disabled");
    let nextVisible = getNextVisibleSlideIndex();
    nextSlide.classList[nextVisible >= Q3.data.slides.length ? "add" : "remove"]("last-visible-slide");
    prevSlide.classList[prev && firstVisibleSlide !== SlideManager.activeSlide ? "remove" : "add"]("disabled");
}

function setPlayPauseEnabled(state) {
    play.classList[state ? "remove" : "add"]("disabled");
    playPauseEnabled = state;
}

function getNextVisibleSlideIndex(slide) {
    let activeSlide = slide || SlideManager.activeSlide;
    let targetSlide = activeSlide + 1;

    while (Q3.data.slides[targetSlide] && Q3.data.slides[targetSlide].visible === false) {
        targetSlide++;
    }

    return targetSlide;
}

function goToNextVisibleSlide({ userAction = false, ignore = false, quizSubmit = false } = {}) {
    if (Q3.teachMode) {
        onSlideEndedInTeachMode()
        return;
    }
    if (userAction && Q3.isTransitioning) return;

    let targetSlide = getNextVisibleSlideIndex();

    SlideManager.waitForSlide(targetSlide).then(function () {
        let fromInfinite = Boolean(SlideManager.currentSlide.slideInfinite);
        const slideQuiz = SlideManager.currentSlide.slideQuiz;

        if (slideQuiz && slideQuiz.active && !slideQuiz.isSubmitted && !slideQuiz.isInteractive)
            return;

        if (ignore || QuizManager.checkQuizesAnswers(SlideManager.activeSlide)) {
            if (!Q3.data.slides[targetSlide] || SlideManager.activeSlide === (Q3.data.slides.length - 1))
                stopAutoplay();

            timeOnSlide = 0;
            pausedTimeStamp = resumedTimestamp = new Date().getTime();

            setNextSlide(targetSlide, { userAction });
        }

        if (
            Q3.data.setups.showAutoPlayBtn
            && !autoplayEnabled
            && (QuizManager.checkQuizesAnswers({ slideToCheck: targetSlide, onlySlideQuiz: true, noBox: true }))
        ) resumeTourPlayback({ fromInfinite, targetSlide, isSlideSwitch: true });

        mediaFinished = false;

        updateAutoplayTimeout();
    });
}

function stopAutoplay(opts = {}) {
    autoplayEnabled = false;
    if (Q3.data.setups.cartoonUI) {
        play.innerHTML = `<i class='visible-desktop cartoon-icon'>${icons.cartoon_play}</i><i class='visible-mobile cartoon-icon'>${icons.cartoon_play}</i>`;
    } else {
        play.innerHTML = `<img class='visible-desktop' src="data:image/svg+xml;utf8,${icons.play}"><img class='visible-mobile' src="data:image/svg+xml;utf8,${icons.playMob}">`;
    }
    play.title = 'Play';

    if (opts.byQuiz) {
        clearSlideTimeout();
        setPlayPauseEnabled(false);
    } else {
        !opts.byQuiz && updateAutoplayTimeout();
    }
};

function goToPrevVisibleSlide({ userAction = false, wheelAction = false } = {}) {
    if (userAction && Q3.isTransitioning) return;

    let firstVisibleSlide = SlideManager.getFirstVisibleSlide();

    if (firstVisibleSlide === null) firstVisibleSlide = 0;
    if (SlideManager.activeSlide === firstVisibleSlide) return;

    let targetSlide = SlideManager.activeSlide - 1;
    let fromInfinite = Boolean(SlideManager.currentSlide.slideInfinite);

    while (Q3.data.slides[targetSlide].visible === false && targetSlide) { targetSlide--; }
    if (wheelAction && !Q3.data.slides[targetSlide].scrollAdvance) return;

    timeOnSlide = 0;
    pausedTimeStamp = resumedTimestamp = new Date().getTime();

    SlideManager.setSlide(targetSlide, { userAction });

    if (targetSlide === firstVisibleSlide) prevSlide.classList.add('disabled');

    QuizManager.hideQuizBox();

    if (Q3.data.setups.showAutoPlayBtn
        && !autoplayEnabled &&
        (QuizManager.checkQuizesAnswers({ slideToCheck: targetSlide, onlySlideQuiz: true, noBox: true }))
    ) resumeTourPlayback({ fromInfinite, isSlideSwitch: true });

    updateAutoplayTimeout();

    checkIfNextSlideAllowed(targetSlide);
}

function goToSlide(targetSlide, opts) {
    timeOnSlide = 0;
    pausedTimeStamp = resumedTimestamp = new Date().getTime();

    let fromInfinite = Boolean(SlideManager.currentSlide.slideInfinite);

    SlideManager.setSlide(targetSlide, opts);

    if (SlideManager.activeSlide === 0) prevSlide.classList.add('disabled');

    Q3.data.setups.showAutoPlayBtn && !autoplayEnabled && resumeTourPlayback({ fromInfinite, isSlideSwitch: true });

    updateAutoplayTimeout();
}

function setNextSlide(slide, opts) {
    if (slide === undefined) slide = SlideManager.activeSlide + 1;

    if (slide === (Q3.data.slides.length)) {
        QuizManager.showRateScreen();
        SlideManager.activeSlideAudio.pause();
    } else SlideManager.setSlide(slide, { userAction: opts.userAction });

    if (!Q3.isTransitioning) prevSlide.classList.remove('disabled');

    checkIfNextSlideAllowed(slide);
}

function checkIfNextSlideAllowed(slide) {
    if (!allowBusySlides) {
        let nextVisibleSlide = slide + 1;
        let foundSlide = false;

        while (SlideManager.slideCount > nextVisibleSlide && !foundSlide) {
            if (SlideManager.getSlide(nextVisibleSlide).visible !== false) {
                foundSlide = true;
            } else nextVisibleSlide = nextVisibleSlide + 1;
        }

        if (Q3.SlideManager.slideCount > nextVisibleSlide && !AssetsBusy.isSlideReady(nextVisibleSlide))
            nextSlide.classList.add('loading');
        else nextSlide.classList.remove('loading');
    }
}

function langsOnCurrentSlide() {
    return langMap.reduce((counter, l) => {
        if (SlideManager.currentSlide[l.audiokey])
            counter++;

        return counter;
    }, 0);
};

function layerTranslationsOnCurrentSlide() {
    let translatedLayers = 0;

    Object.keys(SlideManager.currentSlide.layers2D).forEach((uuid) => {
        if (SlideManager.currentSlide.layers[uuid]) {
            let layerData = Q3.data.layers.layers2D[uuid];

            if (layerData) {
                let objectData = layerData.objects[Object.keys(layerData.objects)[0]];
                let translationsData = objectData && objectData.translations;

                if (translationsData && Object.keys(translationsData).length >= 2)
                    translatedLayers++
            }
        }
    });

    return translatedLayers;
}

function hasSlideDuration() {
    let slide = Q3.SlideManager.activeSlide;
    let slideData = Q3.data.slides[slide];

    return typeof slideData.slideDuration === "number";
}

function onMediaEnded(s) {
    let mediaDuration = s * 1000;

    mediaFinished = true;

    if (autoplayEnabled) {
        if (hasSlideDuration()) {
            let slideDuration = Q3.data.slides[Q3.SlideManager.activeSlide].slideDuration * 1000;

            console.log(mediaDuration, slideDuration)

            if (slideDuration <= mediaDuration) goToNextVisibleSlide();
            else {
                resumedTimestamp = new Date().getTime();
                timeOnSlide = mediaDuration;
                updateAutoplayTimeout()
            }
        } else goToNextVisibleSlide();
    }
}

function getDuration() {
    let prevSlide = false;
    let slide = SlideManager.activeSlide;
    let slideData = Q3.data.slides[slide];
    let slideDuration = typeof slideData.slideDuration === "number"
        ? slideData.slideDuration
        : typeof slideData.autoplayDelay === "number"
            ? slideData.autoplayDelay
            : Q3.data.setups.autoplayDelay;

    if (slide > 0) {
        for (let i = slide - 1; i >= 0; i--) {
            if (Q3.data.slides[i].visible) {
                prevSlide = i;
                break;
            }
        }
    }

    let transitionDuration = typeof prevSlide === "number"
        ? Q3.data.slides[prevSlide].camera.time || 1
        : 0;

    slideDuration += transitionDuration;

    return slideDuration * 1000;
}

function clearSlideTimeout() {
    if (goId) {
        clearTimeout(goId);
        goId = undefined;
    }
}

function onSlideEndedInTeachMode() {
    slideFinished = true;
    mediaIsPlaying = 0;
    if (Q3.data.setups.cartoonUI) {
        play.innerHTML = `<i class='visible-desktop cartoon-icon'>${icons.cartoon_play}</i><i class='visible-mobile cartoon-icon'>${icons.cartoon_pause}</i>`;
    } else {
        play.innerHTML = `<img class='visible-desktop' src="data:image/svg+xml;utf8,${icons.play}"><img class='visible-mobile' src="data:image/svg+xml;utf8,${icons.pauseMob}">`;
    }
    play.title = 'Play';
    autoplayEnabled = false;
}

function restartSlideInTeachMode() {
    slideFinished = false;
    autoplayEnabled = true;
    if (Q3.data.setups.cartoonUI) {
        play.innerHTML = `<i class='visible-desktop cartoon-icon'>${icons.cartoon_pause}</i><i class='visible-mobile cartoon-icon'>${icons.cartoon_pause}</i>`;
    } else {
        play.innerHTML = `<img class='visible-desktop' src="data:image/svg+xml;utf8,${icons.pause}"><img class='visible-mobile' src="data:image/svg+xml;utf8,${icons.pauseMob}">`;
    }
    play.title = 'Pause';
    SlideManager.setSlide(Q3.SlideManager.activeSlide, { teachModeEvent: true, force: true })
}

function updateAutoplayTimeout() {
    clearSlideTimeout();
    Events.unlisten("mediaEnded", onMediaEnded);

    Q3.isPlaying = autoplayEnabled;

    let slide = SlideManager.activeSlide;

    if (autoplayEnabled && !Q3.data.slides[slide].slideInfinite) {
        let duration = getDuration();
        let videos = Object.keys(Q3.data.slides[slide].layers2D).filter(uuid =>
            Q3.data.slides[slide].layers[uuid]
            && Q3.data.layers.layers2D[uuid]
            && Q3.data.layers.layers2D[uuid].subtype === "videos");

        mediaIsPlaying = 0;

        videos.forEach((uuid) => {
            let videoLayerData = Q3.data.layers.layers2D[uuid];
            let videoData = videoLayerData.objects[Object.keys(videoLayerData.objects)[0]];

            if (videoData.autoplay !== false && !videoData.loop)
                mediaIsPlaying++;
        });

        if (Q3.data.slides[slide][Q3.currentAudioKey] && Q3.data.slides[slide].audioThisSlideOnly)
            mediaIsPlaying++;

        if (mediaIsPlaying > 0 && !mediaFinished) Events.listen("mediaEnded", onMediaEnded)
        else if (duration > 0) {
            goId = setTimeout(function () {
                goId = undefined;

                if (Q3.teachMode) onSlideEndedInTeachMode()
                else goToNextVisibleSlide();

            }, duration - timeOnSlide);
        } else {
            if (Q3.data.setups.cartoonUI) {
                play.innerHTML = `<i class='visible-desktop cartoon-icon'>${icons.cartoon_play}</i><i class='visible-mobile cartoon-icon'>${icons.cartoon_pause}</i>`;
            } else {
                play.innerHTML = `<img class='visible-desktop' src="data:image/svg+xml;utf8,${icons.play}"><img class='visible-mobile' src="data:image/svg+xml;utf8,${icons.pauseMob}">`;
            }
            play.title = 'Play';
            autoplayEnabled = false;
        }
    }

    if (autoplayEnabled && Q3.data.slides[slide].slideInfinite) {
        setPlayPauseEnabled(false)
        if (Q3.data.setups.cartoonUI) {
            play.innerHTML = `<i class='visible-desktop cartoon-icon'>${icons.cartoon_play}</i><i class='visible-mobile cartoon-icon'>${icons.cartoon_pause}</i>`;
        } else {
            play.innerHTML = `<img class='visible-desktop' src="data:image/svg+xml;utf8,${icons.play}"><img class='visible-mobile' src="data:image/svg+xml;utf8,${icons.pauseMob}">`;
        }
        play.title = 'Play';
        autoplayEnabled = false;
    }
}

function resumeTourPlayback({ fromInfinite = false, isSlideSwitch = false, targetSlide = 0 } = {}) {
    if (Q3.teachMode === "teacher") {
        parent.postMessage({
            type: "teachMode",
            action: "autoplay_resume"
        }, '*');
    }

    Q3.Analytics.add({ type: "tour_resumed" });

    if (Q3.teachMode && slideFinished) restartSlideInTeachMode();

    let duration = getDuration();

    if (duration > 0) {
        autoplayEnabled = true;

        if (Q3.data.setups.cartoonUI) {
            play.innerHTML = `<i class='visible-desktop cartoon-icon'>${icons.cartoon_pause}</i><i class='visible-mobile cartoon-icon'>${icons.cartoon_pause}</i>`;
        } else {
            play.innerHTML = `<img class='visible-desktop' src="data:image/svg+xml;utf8,${icons.pause}"><img class='visible-mobile' src="data:image/svg+xml;utf8,${icons.pauseMob}">`;
        }
        play.title = 'Pause';

        setPlayPauseEnabled(true);

        if (!fromInfinite && !isSlideSwitch) Events.fire("autoplay_resume");

        resumedTimestamp = new Date().getTime();

        updateAutoplayTimeout();

        Q3.layers.stack.filter(l => l.subtype === "lottie").forEach(l => {
            let obj = l.objects[0];
            if (obj) obj.play();
        });

        Q3.mediaIsPlaying.length && Q3.mediaIsPlaying.forEach((media) => {
            if (targetSlide < Q3.data.slides.length) media.play();
            else media.delete();
        });

        Q3.backgroundAudio.src && Q3.backgroundAudio.duration !== Q3.backgroundAudio.currentTime && Q3.backgroundAudio.play();

        Q3.layers.stack.filter(l => l.type === "2D").forEach(l => {
            let obj = l.objects[0];

            if (obj && obj.enterExitCtrl && obj.enterExitCtrl.isPaused)
                obj.enterExitCtrl.play();
        });

        TweenMax.resumeAll();

        Q3.controls.autoRotate = Q3.SlideManager.currentSlide.controls ? Boolean(Q3.SlideManager.currentSlide.controls.autoRotate) : false;

        Object
            .values(Q3.mixer.objectsActions)
            .filter(a => a.activeAction !== null)
            .forEach(a => a.activeAction.paused = false);
    } else goToNextVisibleSlide({ userAction: true });
}

function pauseTourPlayback() {
    if (Q3.teachMode === "teacher") {
        parent.postMessage({
            type: "teachMode",
            action: "autoplay_pause"
        }, '*');
    }

    Q3.Analytics.add({ type: "tour_paused" });
    autoplayEnabled = false;

    if (Q3.data.setups.cartoonUI) {
        play.innerHTML = `<i class='visible-desktop cartoon-icon'>${icons.cartoon_play}</i><i class='visible-mobile cartoon-icon'>${icons.cartoon_play}</i>`;
    } else {
        play.innerHTML = `<img class='visible-desktop' src="data:image/svg+xml;utf8,${icons.play}"><img class='visible-mobile' src="data:image/svg+xml;utf8,${icons.playMob}">`;
    }
    play.title = 'Play';

    Events.fire("autoplay_pause");

    updateAutoplayTimeout();

    mediaIsPlaying = 0;
    pausedTimeStamp = new Date().getTime();

    timeOnSlide = timeOnSlide + pausedTimeStamp - resumedTimestamp;

    if (Q3.mediaIsPlaying.length)
        Q3.mediaIsPlaying.forEach(media => media.pause());

    Q3.layers.stack.filter(l => l.subtype === "lottie").forEach(l => {
        let obj = l.objects[0];
        if (obj) obj.pause();
    });

    Q3.backgroundAudio.pause();

    Q3.layers.stack.filter(l => l.type === "2D").forEach(l => {
        let obj = l.objects[0];

        if (obj.enterExitCtrl) obj.enterExitCtrl.pause();
    });

    TweenMax.pauseAll();

    Q3.controls.autoRotate = false;

    Object
        .values(Q3.mixer.objectsActions)
        .filter(a => a.activeAction !== null).forEach(a => a.activeAction.paused = true);
}

function playPauseClickHandler(e) {
    if (Q3.slideChangeDisabled || !playPauseEnabled) return;
    if (e) e.stopImmediatePropagation();
    if (goId || mediaIsPlaying) pauseTourPlayback();
    else resumeTourPlayback();
}

class ObjectAnimationPlayer {
    constructor() {
        this._playingObjectAnimations = new Map();
        this._pendingObjectAnimations = new Map();
        this._paused = false;
    }

    isPaused() {
        return this._paused;
    }

    setPaused(paused) {
        paused = Boolean(paused);

        if (paused === this._paused) {
            return;
        }

        this._paused = paused;

        if (paused) {
            for (let [objectUuid, animationUuid] of this._playingObjectAnimations) {
                Q3.mixer.pauseObjectCurrentAnimation(objectUuid);
            }
        } else {
            for (let [objectUuid, animationUuid] of this._playingObjectAnimations) {
                Q3.mixer.playObjectAnimation({ objectUuid, animationUuid, resume: true });
            }

            for (let [objectUuid, animationUuid] of this._pendingObjectAnimations) {
                Q3.mixer.loadAndPlay({ objectUuid, animationUuid });
                this._playingObjectAnimations.set(objectUuid, animationUuid);
            }

            this._pendingObjectAnimations.clear();
        }
    }

    setObjectAnimation(objectUuid, animationUuid) {
        if (animationUuid) {
            if (this._paused) {
                this._playingObjectAnimations.delete(objectUuid);
                this._pendingObjectAnimations.set(objectUuid, animationUuid);
                Q3.mixer.stopObjectCurrentAnimation(objectUuid, 0);
            } else {
                this._playingObjectAnimations.set(objectUuid, animationUuid);
                Q3.mixer.loadAndPlay({ objectUuid, animationUuid });
            }
        } else {
            this._playingObjectAnimations.delete(objectUuid);
            this._pendingObjectAnimations.delete(objectUuid);
            Q3.mixer.stopObjectCurrentAnimation(objectUuid, 0);
        }
    }

    markObjectAnimation(objectUuid, animationUuid) {
        this._playingObjectAnimations.set(objectUuid, animationUuid);
    }
}

function addSlideControls() {
    if (Utils.queryParams.has("show-timeonslide")) {
        const timeOnSlideEl = document.createElement("div");
        const styles = {
            fontSize: "2rem",
            color: "yellow",
            textShadow: "0 0 1px black 0 0 1px black",
            position: "absolute",
            pointerEvents: "none",
            top: 0,
            left: 0,
            padding: '0.5rem',
            zIndex: 20000,
        }
        Object.assign(timeOnSlideEl.style, styles);
        document.body.appendChild(timeOnSlideEl);
        setInterval(() => {
            if (autoplayEnabled)
            timeOnSlideEl.innerText = ((timeOnSlide + Date.now() - resumedTimestamp)/1000).toFixed(2);
        }, 100)
    }

    if (!Q3.editMode && Q3.teachMode) {
        const teacherControlsEl = TeacherControls.init(Q3.container.parentElement);
        controlObjects.push(teacherControlsEl);
    }
    const splash = QuizManager.appendRateScreen();

    let totalScoreEl = $('<div class="total-score"></div>');

    QuizManager.setScoreContainer(totalScoreEl[0]);

    controlObjects.push(splash);

    if (!Q3.editMode && Utils.queryParams.has("total_score")) {
        $(Q3.container.parentElement).append(totalScoreEl);
        controlObjects.push(totalScoreEl);
    }

    Q3.controlsBox = document.createElement('div');
    Q3.controlsBox.className = 'controls-box main-control';

    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    Q3.controlsBoxRight = document.createElement('div');
    Q3.controlsBoxRight.className = 'controls-box main-control';
    if (Q3.data.setups.cartoonUI) Q3.controlsBoxRight.className = 'controls-box controls-box-right main-control';

    const slideControls = document.createElement('div');
    slideControls.id = 'slide-controls';
    if (Q3.data.setups.cartoonUI) slideControls.classList.add("cartoon-ui");

    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    const slideControlsRight = document.createElement('div');
    slideControlsRight.id = 'slide-controls';

    slideControlsRight.appendChild(autoSpeed)
    slideControlsRight.appendChild(volume)
    slideControlsRight.appendChild(subtitle)
    slideControlsRight.appendChild(fullscreenCartoonUI)

    if (Q3.data.setups.cartoonUI) {
        autoSpeed.innerHTML = `<i class='visible-desktop cartoon-icon'>${icons.cartoon_autospeed}</i><i class='visible-mobile cartoon-icon'>${icons.cartoon_autospeed}</i>`;
        autoSpeed.id = 'qbix-viewer-button-autospeed';
        autoSpeed.title = 'Autospeed';
        autoSpeed.className = `material-icons`;
        autoSpeed.tabIndex = getTabIndex();

        volume.innerHTML = `<i class='visible-desktop cartoon-icon volume-control'>${icons.cartoon_volume}</i><i class='visible-mobile cartoon-icon'>${icons.cartoon_volume}</i>`;
        volume.id = 'qbix-viewer-button-volume';
        volume.title = 'Volume';
        volume.className = `material-icons`;
        volume.tabIndex = getTabIndex();

        subtitle.innerHTML = `<i class='visible-desktop cartoon-icon ${!Q3.data.setups.showSubTitle ? '' : 'disabled'}'>${icons.cartoon_subtitle}</i><i class='visible-mobile cartoon-icon'>${icons.cartoon_subtitle}</i>`;
        subtitle.id = 'qbix-viewer-button-subtitle';
        subtitle.title = 'Subtitle';
        subtitle.className = `material-icons`;
        subtitle.tabIndex = getTabIndex();
        Q3.data.setups.showSubTitle ? subtitle.style.pointerEvents = 'none' : subtitle.style.pointerEvents = 'initial'

        fullscreenCartoonUI.innerHTML = `<i class='visible-desktop cartoon-icon fullscreen-control'>${icons.cartoon_fullscreen}</i><i class='visible-mobile cartoon-icon'>${icons.cartoon_fullscreen}</i>`;
        fullscreenCartoonUI.id = 'qbix-viewer-button-fullscreenCartoonUI';
        fullscreenCartoonUI.title = 'Full Screen';
        fullscreenCartoonUI.className = `material-icons`;
        fullscreenCartoonUI.tabIndex = getTabIndex();
    } else {
        autoSpeed.innerHTML = ``
        volume.innerHTML = ``
        subtitle.innerHTML = ``
    }

    if (!Q3.editMode && !Q3.slideChangeDisabled) {
        domEventListeners.push([
            autoSpeed,
            "click",
            function(e) {
                e.stopImmediatePropagation();
                playBackRate()
            },
            false
        ]);
    }

    function playBackRate() {
        if (Q3.mediaIsPlaying.length) {
            Q3.mediaIsPlaying.forEach(video => {
                switch (playbackRate) {
                    case 0.5:
                        playbackRate = 2
                        console.log(`rate ${playbackRate}`);
                        break
                    case 1:
                        playbackRate = 0.5
                        console.log(`rate ${playbackRate}`);
                        break
                    case 2:
                        playbackRate = 1
                        console.log(`rate ${playbackRate}`);
                        break
                    default:
                        playbackRate = 1
                }
                video.playbackRate = playbackRate
            })
        }
    }

    if (!Q3.editMode && !Q3.slideChangeDisabled) {
        domEventListeners.push([
            volume,
            "click",
            function (e) {
                e.stopImmediatePropagation();
                volumeToggle()
            },
            false
        ]);
    }

    function volumeToggle() {
        if (Q3.mediaIsPlaying.length) {
            Q3.mediaIsPlaying.forEach(video => {
                video.volume === 1 ? video.volume = 0 : video.volume = 1
                volumeValue = video.volume === 1 ? 0 : 1
            })
            document.querySelector('.volume-control').classList.toggle('volumeNull')
        }
    }

    if (!Q3.editMode && !Q3.slideChangeDisabled) {
        domEventListeners.push([
            subtitle,
            "click",
            function (e) {
                e.stopImmediatePropagation();
                toggleSubtitle()
            },
            false
        ]);
    }

    function toggleSubtitle() {
        isShowSubtitles === false ? isShowSubtitles = true : isShowSubtitles = false
        document.querySelector('#subtitles').style.display = !isShowSubtitles ? 'flex' : 'none'
    }

    domEventListeners.push([
        fullscreenCartoonUI,
        "click",
        function (event) {
            event.stopImmediatePropagation();

            const isItFullScreen = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
            const fullscreenBtn = document.querySelector('.fullscreen-control')
            if (!isItFullScreen) {
                fullscreenBtn.classList.add("full-screen-active");

                requestFullScreen();
                Q3.Analytics.add({ type: "fullscreenchange", action: "enter" })
            } else {
                function requestExitFullScreen() {
                    const root = document;
                    const onResize = () => resize();

                    if (root.exitFullscreen) root.exitFullscreen().then(onResize);
                    else if (root.webkitCancelFullScreen) root.webkitCancelFullScreen.then(onResize);
                    else if (root.webkitExitFullscreen) root.webkitExitFullscreen().then(onResize);
                    else if (root.mozCancelFullScreen) root.mozCancelFullScreen().then(onResize);
                    else if (root.msExitFullscreen) root.msExitFullscreen().then(onResize);
                }
                fullscreenBtn.classList.remove("full-screen-active");
                requestExitFullScreen();
                Q3.Analytics.add({ type: "fullscreenchange", action: "exit" })
            }
        },
        false
    ]);

    if (Q3.data.setups.cartoonUI) slideControlsRight.classList.add("cartoon-ui");

    Q3.controlsBox.appendChild(slideControls);

    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    Q3.controlsBoxRight.appendChild(slideControlsRight)

    controlObjects.push(slideControls, slideControlsRight, Q3.controlsBox, Q3.controlsBoxRight);

    if (Q3.data.setups.cartoonUI) {
        prevSlide.innerHTML = `<i class='visible-desktop cartoon-icon'>${icons.cartoon_prev}</i><i class='visible-mobile cartoon-icon'>${icons.cartoon_prev}</i>`;
    } else {
        prevSlide.innerHTML = `<img class='visible-desktop' src="data:image/svg+xml;utf8,${icons.rwnd}"><img class='visible-mobile' src="data:image/svg+xml;utf8,${icons.rwndMob}">`;
    }
    prevSlide.id = 'qbix-viewer-button-previous';
    prevSlide.title = 'Previous';
    prevSlide.className = `material-icons ${Q3.SlideManager.activeSlide ? "" : " disabled"}`;
    prevSlide.tabIndex = getTabIndex();

    if (!Q3.editMode && !Q3.slideChangeDisabled) {
        domEventListeners.push([
            prevSlide,
            "click",
            function (e) {
                e.stopImmediatePropagation();
                goToPrevVisibleSlide({ userAction: true });
            },
            false
        ]);
    }

    controlObjects.push(QuizManager.addQuizbox());
    play.tabIndex = getTabIndex();

    if (Q3.data.setups.cartoonUI) {
        nextSlide.innerHTML = `<i class='visible-desktop cartoon-icon'>${icons.cartoon_next}</i><i class='visible-mobile cartoon-icon'>${icons.cartoon_next}</i>`;
    } else {
        nextSlide.innerHTML = `<img class='visible-desktop' src="data:image/svg+xml;utf8,${icons.ffwd}"><img class='visible-mobile' src="data:image/svg+xml;utf8,${icons.ffwdMob}">`;
    }
    nextSlide.id = 'qbix-viewer-button-next';
    nextSlide.title = 'Next';
    nextSlide.className = 'material-icons';
    nextSlide.tabIndex = getTabIndex();

    if (!allowBusySlides) {
        function onSlideReady(slideIndex) {
            if (SlideManager.activeSlide + 1 === slideIndex) {
                nextSlide.classList.remove("loading");
            }
        }

        checkIfNextSlideAllowed(SlideManager.activeSlide);

        gEventListeners.push(["slide_ready", onSlideReady]);
    }

    if (!Q3.editMode && !Q3.slideChangeDisabled) {
        domEventListeners.push([
            nextSlide,
            "click",
            function (e) {
                e.stopImmediatePropagation();
                goToNextVisibleSlide({ userAction: true, ignore: true });
            },
            false
        ]);
    }

    if (Q3.data.setups.cartoonUI) {
        play.innerHTML = `<i class='visible-desktop cartoon-icon'>${icons.cartoon_play}</i><i class='visible-mobile cartoon-icon'>${icons.cartoon_play}</i>`;
    } else {
        play.innerHTML = `<img class='visible-desktop' src="data:image/svg+xml;utf8,${icons.play}"><img class='visible-mobile' src="data:image/svg+xml;utf8,${icons.playMob}">`;
    }
    play.id = 'qbix-viewer-button-play';
    play.title = 'Play';
    play.className = 'material-icons';
    domEventListeners.push([play, "click", playPauseClickHandler, false]);

    if (!Q3.editMode && !Q3.slideChangeDisabled)
        domEventListeners.push([window, "keyup", onKeyUp]);

    function onKeyUp(e) {
        if ($("#rate-screen").hasClass("active")) return;
        //don't change slide if arrow used inside an input
        if (document.activeElement instanceof HTMLInputElement
            || document.activeElement instanceof HTMLTextAreaElement
            || document.activeElement.classList.contains("player-slider")
            || Q3.edittingText)
            return;
        if (e.key === 'ArrowLeft' || e.key === 'PageUp') {
            goToPrevVisibleSlide({ userAction: true, ignore: true });
        } else if (e.key === 'ArrowRight' || e.key === 'PageDown') {
            goToNextVisibleSlide({ userAction: true, ignore: true });
        } else if (e.keyCode === 32) {
            playPauseClickHandler();
        }

    }

    const currentSlide = document.createElement('span');
    currentSlide.innerHTML = String(SlideManager.activeSlide + 1);

    let slideMarkersCnt = document.createElement("div");

    slideMarkersCnt.id = 'slide-markers';

    if (!Q3.editMode && !Q3.assetMode) {
        Q3.container.parentElement.appendChild(slideMarkersCnt);
        controlObjects.push(slideMarkersCnt);
    }

    const slideMarkers = [];

    for (let i = 0; i < Q3.data.slides.length; i++) {
        let dot = document.createElement("div")
        dot.className = "dot"
        slideMarkersCnt.appendChild(dot);
        slideMarkers.push(dot);
    }

    const updateSlideMarkers = () => {
        slideMarkers.forEach(d => { d.className = "dot" });

        for (let i = 0; i < SlideManager.activeSlide; i++)
            slideMarkers[i].className = "dot active"

        const marker = slideMarkers[SlideManager.activeSlide];

        marker.className = "dot active current"
    }

    if (!Q3.editMode) updateSlideMarkers();

    let slideChangeDropdown = false;

    const slideChangeHandler = () => {
        currentSlide.innerHTML = SlideManager.activeSlide + 1;

        if (slideChangeDropdown)
            slideChangeDropdown.value = SlideManager.activeSlide;

        if (!Q3.editMode) updateSlideMarkers();

        if (Q3.editMode) {
            prevSlide.classList[SlideManager.activeSlide === 0 ? "add" : "remove"]("disabled");
            nextSlide.classList[SlideManager.activeSlide === Q3.data.slides.length - 1 ? "add" : "remove"]("disabled");
        }
    };

    if (Q3.editMode) slideChangeHandler();

    gEventListeners.push(["slidechange", slideChangeHandler]);
    gEventListeners.push(["finishtour", function () { QuizManager.showRateScreen(); }]);

    const totalSlide = document.createElement('span');
    totalSlide.innerHTML = Q3.data.slides.length;
    totalSlide.id = "total-slide-count";

    if (Q3.editMode) {
        gEventListeners.push([
            "slideCountChange",
            function () {
                totalSlide.innerHTML = Q3.data.slides.length;
                slideChangeHandler();
            }
        ]);
    }

    const slideCountWrap = document.createElement('div');
    slideCountWrap.id = 'slide-count-wrap';
    if (Q3.data.setups.cartoonUI) slideCountWrap.id = 'controlls-hidden';


    if (Q3.container.parentElement.classList.contains("slidechange-dropdown") && !Q3.teachMode) {
        slideChangeDropdown = document.createElement("select");
        slideChangeDropdown.className = "slide-change-dropdown"

        Q3.data.slides.forEach((s, i) => {
            let opt = document.createElement("option");
            opt.innerHTML = i + 1 + (s.visible ? "" : "(hidden)")
            opt.value = i;
            slideChangeDropdown.appendChild(opt)
        });

        slideChangeDropdown.value = Q3.SlideManager.activeSlide;
        domEventListeners.push([
            slideChangeDropdown,
            "input",
            event => goToSlide(parseInt(event.target.value), { userAction: true })
        ]);

        slideCountWrap.appendChild(slideChangeDropdown);
    }

    if (Q3.nouicontrols) slideCountWrap.className = 'controls-box hidden';
    else slideCountWrap.className = 'controls-box';

    slideCountWrap.appendChild(currentSlide);

    const ofSpan = document.createElement("span");

    ofSpan.className = "of";
    slideCountWrap.appendChild(ofSpan);
    slideCountWrap.appendChild(totalSlide);

    if (!Q3.data.slides[0].hideControls
        && !Q3.slideChangeDisabled
        && !Q3.teachMode) slideControls.appendChild(prevSlide);

    if (Q3.data.setups.showAutoPlayBtn && Q3.data.slides.length > 1) {
        (
            Q3.container.parentElement.classList.contains("embibe-controls")
                ? Q3.container.parentElement
                : slideControls
        ).appendChild(slideCountWrap);

        controlObjects.push(slideCountWrap);

        if (!Q3.editMode) {
            play.style.display = "flex";

            if (!Q3.slideChangeDisabled && Q3.teachMode !== "student") {
                (
                    Q3.container.parentElement.classList.contains("embibe-controls")
                        ? slideControls
                        : slideCountWrap
                ).appendChild(play);
            }

            resumedTimestamp = new Date().getTime();
            pausedTimeStamp = resumedTimestamp;

            if (getDuration() > 0) playPauseClickHandler();
        }
    }

    const calloutsMode = Utils.queryParams.get("callouts") === "true";
    if (Q3.assetMode !== 'view') {
        (Q3.container.parentElement.classList.contains("embibe-controls")
            ? Q3.container.parentElement
            : slideControls).appendChild(slideCountWrap);
        controlObjects.push(slideCountWrap);
    } else if (!calloutsMode) {
        Q3.RenderManager.background.setBackground({
            type: "color",
            value: {
                color: {
                    primary: "#6932ff",
                    secondary: "#083f8f",
                    gradient: {
                        enabled: true,
                        style: "radial"
                    }
                }
            }
        });
    }

    const objectAnimationPlayer = new ObjectAnimationPlayer();

    if (Q3.assetMode === 'view') {
        let helpersVisible = false;

        let objectNameEl = document.createElement('div');

        objectNameEl.id = "asset-viewer-obj-name";
        Q3.container.parentElement.appendChild(objectNameEl);
        controlObjects.push(objectNameEl);

        let assetNameEl = document.createElement('div');

        assetNameEl.id = "asset-viewer-asset-name";
        Q3.container.parentElement.appendChild(assetNameEl);
        controlObjects.push(assetNameEl);

        if (!Utils.queryParams.get('no-edit')) {
            let edtButton = document.createElement('a');

            edtButton.innerHTML = `<img src="/images/icons/edit-mode-w.svg"/>`;
            edtButton.id = "asset-viewer-edit";
            edtButton.setAttribute("target", "_blank");
            edtButton.href = `${window.COOBO ? "/api" : ""}/edit_asset/${Q3.data.assetId}`;
            Q3.container.parentElement.appendChild(edtButton);
            controlObjects.push(edtButton);
        }

        let assetDetails = document.createElement('div');

        assetDetails.id = "asset-viewer-details";
        assetDetails.className = "active";
        Q3.container.parentElement.appendChild(assetDetails);
        controlObjects.push(assetDetails);

        let assetSyncThumb = createGenThumbButton(() => helpersVisible, {name: 'Sync Thumbnail', isSync: true});
        assetSyncThumb.id = "asset-viewer-sync-thumb";
        Q3.container.parentElement.appendChild(assetSyncThumb);
        controlObjects.push(assetSyncThumb);

        let assetFullHdThumb = createGenThumbButton(() => helpersVisible, {name: 'Generate Full HD', isFullHd: true});
        assetFullHdThumb.id = "asset-viewer-full-hd-thumb";
        Q3.container.parentElement.appendChild(assetFullHdThumb);
        controlObjects.push(assetFullHdThumb);

        let assetGenThumb = createGenThumbButton(() => helpersVisible);

        assetGenThumb.id = "asset-viewer-gen-thumb";
        Q3.container.parentElement.appendChild(assetGenThumb);
        controlObjects.push(assetGenThumb);

        let assetBgColor = document.createElement('div');

        assetBgColor.id = "asset-viewer-bg-color";
        Q3.container.parentElement.appendChild(assetBgColor);
        controlObjects.push(assetBgColor);

        let input = document.createElement('input');

        input.type = "color";
        input.id = "bg-color";
        input.value = "#ffffff";

        let label = document.createElement('label');

        label.setAttribute("for", "bg-color");
        label.innerHTML = "Background Color";
        assetBgColor.appendChild(input);
        assetBgColor.appendChild(label);

        Q3.RenderManager.background.setBackground({
            type: "color",
            value: {
                color: {
                    primary: calloutsMode ? "transparent" : "#6932ff",
                    secondary: calloutsMode ? "transparent" : "#083f8f",
                    gradient: {
                        enabled: !calloutsMode,
                        style: "radial"
                    }
                }
            }
        });

        domEventListeners.push([
            input,
            "change",
            function (event) {
                Q3.RenderManager.background.setBackground({
                    type: "color",
                    value: {
                        color: {
                            primary: event.target.value,
                            secondary: "#083f8f",
                            gradient: {
                                enabled: false,
                                style: "radial"
                            }
                        }
                    }
                });
            }
        ]);

        let labelControls = document.createElement('div');

        labelControls.id = "asset-viewer-label-controls";
        Q3.container.parentElement.appendChild(labelControls);
        controlObjects.push(labelControls);

        let wrap = document.createElement("div");

        wrap.className = "q3-tab-explorer";

        let list = document.createElement("div");

        list.className = "tab-list";
        labelControls.appendChild(wrap);
        wrap.appendChild(list);

        let selectedLabelsBtn;

        let checkbox = document.createElement('input')
        checkbox.setAttribute('type', 'checkbox')
        checkbox.classList.add('halpers-ckeckbox')

        let helpersBtn = document.createElement("div");
        helpersBtn.className = "tab-label language-selector";
        helpersBtn.innerHTML = "Helpers";
        domEventListeners.push([
            helpersBtn,
            "click",
            function () {
                Q3.boundingBoxHelpers.forEach(h => h.visible = !helpersVisible);
                Q3.RenderManager.activeCamera.update = true;
                helpersVisible = !helpersVisible;
                checkbox.checked = helpersVisible
                checkbox.classList[helpersVisible ? 'add' : 'remove']('checked')
                // helpersBtn.innerHTML = `Helpers ${helpersVisible ? "On" : "Off"}`;
                // helpersBtn.classList[helpersVisible ? "add" : "remove"]("selected");
            }
        ]);
        list.appendChild(helpersBtn);
        helpersBtn.appendChild(checkbox);

        if (!Utils.queryParams.has("no_ui_controls")) {
            [
                { label: "Label Off", value: "hidden", default: true },
                { label: "Label On", value: "visible" },
                { label: "Label: Callouts", value: "callouts" }
            ].forEach(l => {
                let btn = document.createElement("div");

                btn.className = "tab-label";

                if (l.default) {
                    btn.classList.add("selected");
                    selectedLabelsBtn = btn;
                    Q3.labels.live.setGlobalVisibility(l.value);
                    Q3.RenderManager.activeCamera.update = true;
                }

                btn.innerHTML = l.label;

                domEventListeners.push([
                    btn,
                    "click",
                    function () {
                        Q3.labels.live.setGlobalVisibility(l.value);
                        selectedLabelsBtn.classList.remove("selected");
                        selectedLabelsBtn = btn;
                        btn.classList.add("selected");
                        Q3.RenderManager.activeCamera.update = true;
                    }
                ]);

                list.appendChild(btn);
            })
        }

        let langSelector = document.createElement("div");

        langSelector.className = "tab-label language-selector";
        langSelector.innerHTML = "Label language: "

        let select = document.createElement("select");

        const changeLabelLanguage = function (lang) {
            if (Q3.language !== lang) {
                let overlay2d = document.getElementById('overlay2d');
                overlay2d.classList.remove(`locale-${Q3.language}`);
                overlay2d.classList.add(`locale-${lang}`);
            }

            Q3.language = lang;
            Q3.RenderManager.activeCamera.update = true;
        };

        domEventListeners.push([
            select,
            "input",
            event => changeLabelLanguage(event.target.value)
        ]);

        langSelector.appendChild(select);

        langMap.forEach(lang => {
            let opt = document.createElement("option");
            opt.innerHTML = lang.title;
            opt.value = lang.key
            select.appendChild(opt)
        });

        list.appendChild(langSelector);

        let asset = Q3.AssetDeserializer.references[Q3.data.assetId];

        assetNameEl.innerHTML = `<span title="Click to copy name" onclick="copyText(this)">${asset.name}</span>`

        let author = asset.author;
        let authorDiv = "";

        if (author) authorDiv = `<div><b class="row-title">Author:</b> <span style="word-break: break-all">${author.username} (${author.email})</span></div>`;

        let dateDiv = `<div><b class="row-title">Creation Date: </b> ${Utils.getFormattedDate(asset.createdAt)}</div>`;
        let details = Q3.AssetDeserializer.references[Q3.data.assetId].info;
        let detailDiv = document.createElement("div");

        if (details) {
            const geometryRatio = Q3.browserCapabilities.supports.geometries.ratio;

            let dataSizes = [];

            if (details.assetFileSizes) {
                if ('geometries' in details.assetFileSizes) {
                    let geoSizes = details.assetFileSizes.geometries;
                    let geoSize;

                    switch (typeof geoSizes) {
                        case 'number': geoSize = geoSizes; break;
                        case 'object': {
                            let nearestDiff = Infinity;

                            for (let { ratio, size } of geoSizes) {
                                let diff = Math.abs(ratio - geometryRatio);

                                if (diff < nearestDiff) {
                                    geoSize = size;
                                    nearestDiff = diff;
                                }
                            }

                            break;
                        }
                    }

                    if (geoSize) {
                        let size = getFileSizeString(geoSize);

                        dataSizes.push(`<div class="asset-size"><b class="row-title">Geometries:</b>${size}</div>`);
                    }
                }

                const assetTypes = [['textures', 'Textures'], ['animations', 'Animations']];

                for (let [assetType, text] of assetTypes) {
                    let size = details.assetFileSizes[assetType];

                    if (size) {
                        size = getFileSizeString(size);
                        dataSizes.push(`<div class="asset-size"><b class="row-title">${text}:</b>${size}</div>`);
                    }
                }

                if (dataSizes.length > 0) dataSizes = `<div class="data-size-list">${dataSizes.join("")}</div>`;
                else dataSizes = "";

            }

            const hqMode = !Q3.browserCapabilities.supports.textures.lodEnabled;

            let textureDims = "";

            if (details.textureDimensions && details.textureDimensions.length > 0) {
                textureDims = [];

                for (let { width, height, count } of details.textureDimensions) {
                    if (hqMode && !(width === 1 && height === 1)) {
                        width *= 2;
                        height *= 2;
                    }

                    let text = width + 'x' + height + ' (' + count + ')';

                    textureDims.push(`<span>${text}</span>`);
                    textureDims.push(', ');
                }

                textureDims.pop();
                textureDims = `<div class="texture-dims"><b class="row-title">Texture dimensions:</b> ${textureDims.join("")}</div>`;
            }

            let triCount = "";

            if (details.triangleCount) {
                let count;

                switch (typeof details.triangleCount) {
                    case 'number': count = details.triangleCount; break;

                    case 'object': {
                        let nearestDiff = Infinity;

                        for (let { ratio, count: thisCount } of details.triangleCount) {
                            let diff = Math.abs(ratio - geometryRatio);

                            if (diff < nearestDiff) {
                                count = thisCount;
                                nearestDiff = diff;
                            }
                        }

                        break;
                    }
                }

                if (count) triCount = `<div class="poly-count"><b class="row-title">Polygon count:</b> ${count}</div>`;
            }

            let geoRatios = "";

            {
                let options = new Set();

                for (let uuid in Q3.data.assets.geometries) {
                    let geometryData = Q3.data.assets.geometries[uuid];

                    if (geometryData.levels) {
                        for (let { ratio } of geometryData.levels)
                            options.add(ratio);
                    }
                }

                if (options.size > 0) {
                    const activeRatio = Q3.browserCapabilities.supports.geometries.ratio;

                    options.add(1);
                    options.add(activeRatio);

                    options = Array.from(options).sort((a, b) => b - a);
                    options = options.map(ratio => '\t\t<option value="' + ratio + '"' + (ratio === activeRatio ? ' selected' : '') + '>' + ratio * 100 + '%</option>');

                    geoRatios = [
                        '<div class="geo-ratios">',
                        '\t<b class="row-title">Geometry detail:</b>',
                        '\t<select>',
                        options.join('\n'),
                        '\t</select>',
                        '</div>',
                    ].join('\n');
                }
            }

            let rootUuid;

            {
                let rootCount = 0;

                for (let objectUuid in Q3.data.assets.objects) {
                    if (TransformModifiers.isTopLevelOrdinaryObjectData(objectUuid, Q3.data.assets.objects)) {
                        rootUuid = objectUuid;
                        rootCount++;
                    }
                }

                if (rootCount > 1) rootUuid = null;
            }

            const isObjectDeleted = (objectUuid) => {
                for (const slideData of Q3.data.slides) {
                    const animData = slideData.animation[objectUuid];
                    if (animData && !animData.deleted) {
                        return false;
                    }
                }

                return true;
            };

            const isObjectAscendantDeleted = (objectUuid) => {
                while (objectUuid) {
                    const objectData = Q3.data.assets.objects[objectUuid];

                    if (!objectData) {
                        return true;
                    }

                    if (isObjectDeleted(objectUuid)) {
                        return true;
                    }

                    objectUuid = objectData.parent;
                }

                return false;
            };

            const identity = v => v;
            const getAnimationHtmlList = (animationUuids, isAnimAssigned, inputNamePrefix, idPrefix, inputNameAppendUuid, processName, addNone, defaultToRoot) => {
                const animations = [];

                processName = processName || identity;

                const objectAnimations = {}

                animationUuids.forEach((animationUuid, index) => {
                    let { name, object: objectUuid } = Q3.data.assets.animations[animationUuid];

                    if (!objectUuid && defaultToRoot) {
                        objectUuid = rootUuid;
                    }

                    if (isObjectAscendantDeleted(objectUuid)) return;

                    const slideData = Q3.SlideManager.currentSlide.animation[objectUuid];

                    if (!slideData) return;

                    const animation = slideData.animation;
                    const isAnimation = isAnimAssigned && animation ? animationUuid === animation.uuid : false;
                    const checked = isAnimation ? 'checked' : '';

                    if (isAnimation) {
                        objectAnimationPlayer.markObjectAnimation(objectUuid, animationUuid);
                    }

                    let inputName = inputNamePrefix;

                    if (inputNameAppendUuid) inputName += objectUuid;

                    const animationObject = {
                        animationUuid,
                        objectUuid,
                        html: [
                            `<div>`,
                            `\t<input ${checked} type="radio" name="${inputName}" class="anim-name" value=${animationUuid} object="${objectUuid}" id="${idPrefix}${index}"/>`,
                            `\t<label for="${idPrefix}${index}">${processName(name)}</label>`,
                            `</div>`
                        ].join("\n\t\t"),
                    };

                    objectAnimations[objectUuid] = objectAnimations[objectUuid] || {
                        hasAnimation: false,
                        animations: []
                    };

                    objectAnimations[objectUuid].hasAnimation = objectAnimations[objectUuid].hasAnimation || isAnimation;
                    objectAnimations[objectUuid].animations.push(animationUuid);

                    animations.push(animationObject);
                });

                if (addNone) {
                    for (let objectUuid in objectAnimations) {
                        let inputName = inputNamePrefix;

                        if (inputNameAppendUuid) inputName += objectUuid;

                        let checked = '';
                        const animData = Q3.SlideManager.currentSlide.animation[objectUuid];

                        if (animData) {
                            const animation = animData.animation;
                            const isAnimation = animation && animation.uuid;

                            checked = !isAnimation ? 'checked' : '';
                        }

                        const animationObject = {
                            animationUuid: null,
                            objectUuid,
                            html: [
                                `\t\t<div>`,
                                `\t\t\t<input ${checked} type="radio" name="${inputName}" class="anim-name" value="none" object="${objectUuid}" id="anim_none_${objectUuid}"/>`,
                                `\t\t\t<label for="anim_none_${objectUuid}">None</label>`,
                                `\t\t</div>`,
                            ].join('\n'),
                        };

                        animations.push(animationObject);
                    }
                }

                animations.sort((a1, a2) => {
                    if (a1.objectUuid !== a2.objectUuid) {
                        return a1.objectUuid < a2.objectUuid ? -1 : 1;
                    }

                    if (a1.animationUuid === null) return -1;
                    else if (a2.animationUuid === null) return 1;

                    let n1 = Q3.data.assets.animations[a1.animationUuid].name;
                    let n2 = Q3.data.assets.animations[a2.animationUuid].name;

                    if (n1 === n2) return 0;

                    if (n1 === 'All') return -1;
                    else if (n2 === 'All') return 1;

                    return n1 < n2 ? -1 : 1;
                });

                return animations.map(({ html }) => html).join("\n\t\t");
            };

            let animations = "";

            if (details.animationNames && details.animationNames.length > 0) {
                let allAnimUuids = Object.keys(Q3.data.assets.animations).reverse();
                let animationUuids = allAnimUuids.filter(animUuid => !Q3.data.assets.animations[animUuid].isCamAnim && Q3.SlideManager.currentSlide.animation[Q3.data.assets.animations[animUuid].object || rootUuid]);

                if (animationUuids.length > 0) {
                    const objectUuid = Q3.data.assets.animations[animationUuids[0]].object;
                    const noneName = 'animation_' + objectUuid;

                    animations = [
                        "<div>",
                        "<b class='row-title'>Animations:</b>",
                        "\t<div class=\"anim-list\">",
                        "\t\t" + getAnimationHtmlList(animationUuids, true, 'animation_', 'anim_', true, null, true, true),
                        "\t</div></div>"
                    ].join("\n");
                }
            }

            let camera = "";

            if (details.animationNames && details.animationNames.length > 0) {
                let allAnimUuids = Object.keys(Q3.data.assets.animations).reverse();
                let animationUuids = allAnimUuids.filter(animUuid => Q3.data.assets.animations[animUuid].isCamAnim);

                const processName = (rawName) => rawName.slice(9);

                if (animationUuids.length > 0) {
                    camera = [
                        "<div>",
                        "<b class='row-title'>Camera:</b>",
                        "\t<div class=\"anim-list\">",
                        `\t\t<div>`,
                        `\t\t\t<input checked="true" type="radio" name="camera" class="anim-name" value="orbit" id="cam_orbit"/>`,
                        `\t\t\t<label for="cam_orbit">Orbit</label>`,
                        `\t\t</div>`,
                        "\t\t" + getAnimationHtmlList(animationUuids, false, 'camera', 'cam_', false, rawName => rawName.slice(9), false, false),
                        "\t</div></div>"
                    ].join("\n");
                }
            }

            let hierarchy = "";

            if (details.hierarchy) {
                let rootIds = [];
                let childrenIds = [];

                for (let [index, name] of details.hierarchy.names.entries())
                    childrenIds[index] = [];

                for (let [index, parentIndex] of details.hierarchy.parents.entries()) {
                    if (parentIndex === null) rootIds.push(index);
                    else childrenIds[parentIndex].push(index);
                }

                let getObjectEntry, getObjectEntries;

                getObjectEntries = ids => ids.map(getObjectEntry).join("");

                getObjectEntry = (id) => {
                    return (
                        `<div class="object-entry">
                        <div class="name">${details.hierarchy.names[id]}</div>
                        <div class="children">${getObjectEntries(childrenIds[id])}</div>
                    </div>`);
                };

                hierarchy = `<div class="d-flex"><b class="row-title">Object list:</b><div class="hierarchy">${getObjectEntries(rootIds)}</div></div>`;
            }

            let update = "";
            let detailsHeading = $("<h3 class='spoiler-trigger'>DETAILS</h3>");
            let spoilerBlock = $("<div class='spoiler-block'></div>").html(`${authorDiv}${dateDiv}${dataSizes}${textureDims}${triCount}${geoRatios}${animations}${camera}${hierarchy}${update}`);

            spoilerBlock
                .find(".anim-list input")
                .on("change", async ({ target: input }) => {
                    const animationUuid = input.getAttribute("value");
                    const animData = Q3.data.assets.animations[animationUuid];

                    if (animData) {
                        if (!animData.isCamAnim) {
                            const objectUuid = input.getAttribute("object");

                            objectAnimationPlayer.setObjectAnimation(objectUuid, animationUuid);
                        } else Q3.RenderManager.setAssetCamera(animationUuid);
                    } else {
                        if (animationUuid === 'none') {
                            const objectUuid = input.getAttribute("object");

                            objectAnimationPlayer.setObjectAnimation(objectUuid, null);
                        } else if (animationUuid === 'orbit') {
                            const data = Q3.SlideManager.currentSlide.camera;

                            Q3.RenderManager.clearCameraAsset();

                            Q3.RenderManager.activeCamera.position.copy(data.position);
                            Q3.RenderManager.activeCamera.lookAt(data.target.x, data.target.y, data.target.z);
                        }
                    }
                });

            spoilerBlock
                .find(".geo-ratios select")
                .on("change", async ({ target: dropdown }) => {
                    let value = Number(dropdown.value);
                    let url = window.location.href;
                    let qMarkPos = url.indexOf('?');

                    if (qMarkPos === -1) window.location.href = url + '?geo_ratio=' + value;
                    else {
                        let paramStart = url.indexOf('geo_ratio=', qMarkPos + 1);

                        if (paramStart === -1) window.location.href = url + '&geo_ratio=' + value;
                        else {
                            let paramEnd = url.indexOf('&', paramStart);

                            if (paramEnd === -1) paramEnd = url.length;

                            window.location.href = url.substring(0, paramStart) + 'geo_ratio=' + value + url.substring(paramEnd);
                        }
                    }
                });

            detailsHeading.on("click", () => {
                detailsHeading.toggleClass("active");
                spoilerBlock.slideToggle();
            });

            $(detailDiv).append(spoilerBlock);
        }

        assetDetails.appendChild(detailDiv);

        let toggleBtn = document.createElement('div');

        toggleBtn.className = 'toggle-btn';
        domEventListeners.push([
            toggleBtn,
            "click",
            function () { assetDetails.classList.toggle("active") }
        ]);

        assetDetails.appendChild(toggleBtn);
        assetDetails.appendChild(detailDiv);
    }

    if (!Q3.data.slides[0].hideControls
        && !Q3.slideChangeDisabled
        && !Q3.teachMode) slideControls.appendChild(nextSlide);

    Q3.optionsBox = document.createElement('div');
    Q3.optionsBox.id = 'options-box';
    if (Q3.data.setups.cartoonUI) Q3.optionsBox.id = 'controlls-hidden';


    const settings = document.createElement('p');

    settings.innerHTML = '&#xe8b8;';
    settings.className = 'material-icons';

    const download = document.createElement('p');

    download.innerHTML = '&#xe2c4;';
    download.className = 'material-icons';

    const webVrMode = document.createElement('p');

    webVrMode.id = 'qbix-viewer-button-webvr';
    webVrMode.innerHTML = 'all_inclusive';
    webVrMode.className = 'material-icons';
    webVrMode.style.display = "none";

    let playPause;

    if (Q3.assetMode === 'view' && !Utils.queryParams.has("no_ui_controls")) {
        const details = Q3.AssetDeserializer.references[Q3.data.assetId].info;

        if (details.animationNames && details.animationNames.length > 0) {
            playPause = document.createElement('img');

            let paused = false;

            const updateImage = () => playPause.src = '/images/icons/' + (paused ? 'play' : 'pause') + '.svg';
            updateImage();

            domEventListeners.push([
                playPause,
                "click",
                function (event) {
                    event.stopImmediatePropagation();

                    paused = !paused;
                    updateImage();
                    objectAnimationPlayer.setPaused(paused);
                },
                false
            ]);
        }
    }

    const fullscreen = document.createElement('p');

    // fullscreen.innerHTML = '&#xe5d0;';
    fullscreen.innerHTML = '';

    let enter = document.createElement("img");

    enter.src = '/images/icons/enter-fullscreen2.svg';
    enter.className = "enter";
    enter.tabIndex = getTabIndex();

    let exit = document.createElement("img");

    exit.className = "exit";
    exit.tabIndex = getTabIndex();
    exit.src = '/images/icons/exit-fullscreen2.svg';

    fullscreen.appendChild(enter);
    fullscreen.appendChild(exit);

    fullscreen.id = 'qbix-viewer-button-fullscreen';
    fullscreen.title = 'Fullscreen';
    fullscreen.className = 'material-icons';

    domEventListeners.push([
        fullscreen,
        "click",
        function (event) {
            event.stopImmediatePropagation();

            const isItFullScreen = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;

            if (!isItFullScreen) {
                fullscreen.classList.add("active");

                requestFullScreen();
                Q3.Analytics.add({ type: "fullscreenchange", action: "enter" })
            } else {
                function requestExitFullScreen() {
                    const root = document;
                    const onResize = () => resize();

                    if (root.exitFullscreen) root.exitFullscreen().then(onResize);
                    else if (root.webkitCancelFullScreen) root.webkitCancelFullScreen.then(onResize);
                    else if (root.webkitExitFullscreen) root.webkitExitFullscreen().then(onResize);
                    else if (root.mozCancelFullScreen) root.mozCancelFullScreen().then(onResize);
                    else if (root.msExitFullscreen) root.msExitFullscreen().then(onResize);
                }

                fullscreen.classList.remove("active");
                requestExitFullScreen();
                Q3.Analytics.add({ type: "fullscreenchange", action: "exit" })
            }
        },
        false
    ]);

    let isMouseUser = false;

    function detectThing(event) {
        document.body.removeEventListener('touchstart', detectThing);
        document.body.removeEventListener('touchmove', detectThing);
        document.body.removeEventListener('mouseover', detectThing);
        isMouseUser = event.type === 'mouseover';
    }

    domEventListeners.push([document.body, "touchstart", detectThing]);
    domEventListeners.push([document.body, "touchmove", detectThing]);
    domEventListeners.push([document.body, "mouseover", detectThing]);

    let ua = navigator.userAgent.toLowerCase();

    if (playPause) Q3.optionsBox.appendChild(playPause);
    if (!(ua.indexOf('safari') != -1 && ua.indexOf('chrome') === -1)) Q3.optionsBox.appendChild(fullscreen);

    Q3.optionsBox.appendChild(webVrMode);

    Q3.volumeBox = document.createElement('div');
    Q3.volumeBox.id = 'volume-box';
    Q3.volumeBox.style.display = 'none';

    let defVolume = 0.6;
    let muted = false;
    const muteButton = document.createElement('p');

    muteButton.innerHTML = 'volume_up';
    muteButton.className = 'material-icons';
    domEventListeners.push([
        muteButton,
        "click",
        function (e) {
            e.stopImmediatePropagation();
            muted = !muted;
            Q3.backgroundAudio.volume = muted ? 0 : Q3.backgroundAudio.initialVolume ? Q3.backgroundAudio.initialVolume : defVolume;
            SlideManager.activeSlideAudio.volume = muted ? 0 : SlideManager.activeSlideAudio.initialVolume ? SlideManager.activeSlideAudio.initialVolume : defVolume;
            muteButton.innerHTML = muted ? 'volume_off' : 'volume_up';
            Q3.Analytics.add({ type: `${muted ? "mute" : "unmute"}` })
        },
        false
    ]);

    const audioLanguages = $("<div class='audio-lang'></div>");

    langMap.forEach(function (l) {
        let langBtn = $(`<p title="${l.title}" class="material-icons"><img src="${l.img}" alt=""></p>`);

        if ((!Q3.data.slides[0][l.audiokey] || langsOnCurrentSlide() < 2) && !layerTranslationsOnCurrentSlide())
            langBtn.hide();
        else Q3.volumeBox.style.display = 'inline-flex';

        gEventListeners.push([
            "slidechange",
            function () {
                let translatedLayers = layerTranslationsOnCurrentSlide();

                if (!translatedLayers && !SlideManager.currentSlide[l.audiokey])
                    langBtn.hide();
                else if (langsOnCurrentSlide() >= 2 || translatedLayers >= 2) {
                    langBtn.show();
                    Q3.volumeBox.style.display = 'inline-flex';
                }
            }
        ]);

        if (l.default) langBtn.addClass("active");

        langBtn.click(function (e) {
            if (e.currentTarget.classList.contains("active"))
                return;

            langBtn
                .addClass("active")
                .siblings()
                .removeClass("active");

            e.stopImmediatePropagation();

            if (Q3.currentAudioKey !== l.audiokey) {
                Q3.currentAudioKey = l.audiokey;
                Q3.language = l.key;

                Events.fire("langchanged");

                Q3.Analytics.add({ type: "languageChange", lang: Q3.language })
            }
        });

        audioLanguages.append(langBtn);
    });

    domEventListeners.push([
        Q3.backgroundAudio,
        "play",
        function () { Q3.volumeBox.style.display = 'inline-flex' }
    ]);

    domEventListeners.push([
        Q3.backgroundAudio,
        "pause",
        function () { Q3.volumeBox.style.display = 'none' }
    ]);

    domEventListeners.push([
        SlideManager.activeSlideAudio,
        "pause",
        function () { Q3.volumeBox.style.display = 'none' }
    ]);

    domEventListeners.push([
        SlideManager.activeSlideAudio,
        "play",
        function () {
            Q3.volumeBox.style.display = 'inline-flex';
            SlideManager.activeSlideAudio.volume = SlideManager.activeSlideAudio.initialVolume
                ? SlideManager.activeSlideAudio.initialVolume
                : defVolume;
        }
    ]);

    Events.fire('audioInitialized');

    if (!Q3.data.slides[0].hideControls && !Q3.editMode) {
        Q3.container.parentElement.appendChild(Q3.optionsBox);
        Q3.container.parentElement.appendChild(Q3.volumeBox);

        if (Q3.assetMode !== 'view') {
            Q3.container.parentElement.appendChild(Q3.controlsBox);
            Q3.container.parentElement.appendChild(Q3.controlsBoxRight);
            controlObjects.push(Q3.controlsBox, Q3.controlsBoxRight);
        }

        controlObjects.push(Q3.optionsBox, Q3.volumeBox);
    } else {
        Q3.container.parentElement.appendChild(Q3.controlsBox);
        Q3.container.parentElement.appendChild(Q3.controlsBoxRight);
        Q3.controlsBox.classList.add("editor-mode");
        Q3.controlsBoxRight.classList.add("editor-mode");
        controlObjects.push(Q3.controlsBox, Q3.controlsBoxRight);
    }

    if (window.location.href.indexOf('edit') > -1
        && !(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement)) {
        Q3.optionsBox.className = 'hide-controls-box';
        Q3.volumeBox.className = 'hide-controls-box';
    }

    const { slideQuizScoreCnt, mobileQuizCnt } = QuizManager.createQuizWrap();

    if (!Q3.editMode && Q3.assetMode !== 'view') {
        gEventListeners.push([
            "viewportchanged",
            QuizManager.updateQuizWrap.bind(QuizManager)
        ]);

        // const wrappers = new SlideNotes().init($("#viewer"));
        QuizManager.updateQuizWrap();

        // controlObjects.push(...wrappers);
    }

    if (!Q3.editMode) {
        const parentElement = $(Q3.container.parentElement);

        parentElement.append(mobileQuizCnt);
        parentElement.append(slideQuizScoreCnt);

        controlObjects.push(mobileQuizCnt, slideQuizScoreCnt);

        if (Utils.queryParams.has("disablezoom") && Utils.queryParams.get("disablezoom") === "true")
            Q3.controls.enableZoom = false;

        if (Utils.queryParams.has("class_id")) {
            let classId = Utils.queryParams.get("class_id");
            let API_URL = window.API_URL ? window.API_URL : `${window.location.origin}/api`;

            $.ajax({
                url: API_URL + "/student?class=" + classId,
                type: 'GET',
                dataType: 'json',
                success: function (data) {
                    console.log(data);

                    let classTable = $("<div class='students-table-cnt'></div>");
                    let wrapper = $("<div class='students-table-wrap'></div>");
                    let list = $("<div class='students-list'></div>");
                    let startBtn = $("<div class='btn-main disabled'>Start</div>");
                    let titleEl = $('<div class="score-title">Find your name in list!</div>');

                    startBtn.click(function () {
                        if (!Q3.student) return;

                        startTour();
                        classTable.remove();
                    });

                    data.forEach(function (s) {
                        let listItem = $("<div class='list-item'>" + s.name + "</div>");

                        listItem.click(function (e) {
                            $(e.currentTarget).addClass("active").siblings().removeClass("active");
                            Q3.student = { name: s.name, id: s.id, classId: classId };
                            startBtn.removeClass("disabled");
                        });

                        list.append(listItem)
                    });

                    if (!data.length) {
                        titleEl = $('<div class="score-title">Ouch, wrong class link!</div>');
                        const el = classTable.append(wrapper.append(titleEl));

                        $(Q3.container.parentElement).append(el);

                        controlObjects.push(el);
                    } else {
                        const el = classTable.append(wrapper.append(titleEl, list, startBtn));

                        $(Q3.container.parentElement).append(el);

                        controlObjects.push(el);
                    }
                },
            }).catch(function (e) {
                console.error("Couldn't get students list ", e);
            });
        } else startTour();


        RewardScreens.init();
    }

    if (!Q3.editMode && !Q3.assetMode && Q3.data.setups.showAutoPlayBtn) {
        let pausedByOrientationChange = false;

        const onViewportChange = () => {
            if (window.innerWidth / window.innerHeight <= 1) {
                pausedByOrientationChange = pausedByOrientationChange || autoplayEnabled;
                pauseTourPlayback();
            }

            if (window.innerWidth / window.innerHeight > 1 && (!autoplayEnabled && pausedByOrientationChange)) {
                pausedByOrientationChange = false;
                resumeTourPlayback();
            }

        };

        onViewportChange();
        domEventListeners.push([window, "resize", onViewportChange]);
    }

    domEventListeners.push([
        window,
        "message",
        function (event) {
            let data = event.data;

            if (data.type === "previewMessage") {
                if (typeof data.slide === "number") {
                    delete Q3.resumeTimestamp;
                    goToSlide(data.slide, {
                        userAction: true,
                        external: true,
                        teachModeEvent: Boolean(Q3.teachMode)
                    });
                } else if (data.action) {
                    if (data.action === "autoplay_resume") resumeTourPlayback();
                    else if (data.action === "autoplay_pause") pauseTourPlayback()
                }
                if (data.action === "getState") {
                    parent.postMessage({
                        state: {
                            slide: Q3.SlideManager.currentSlide.uuid,
                            timeOnSlide: slideFinished ? getDuration() : (timeOnSlide + new Date().getTime() - resumedTimestamp)
                        }, type: "previewMessage"
                    }, '*');
                }
            }

        },
        false
    ]);

    domEventListeners.forEach(([el, ...params]) => el.addEventListener(...params));
    gEventListeners.forEach(params => Events.listen(...params));
}

function removeSlideControls() {
    controlObjects.forEach(obj => $(obj)[0].remove());
    domEventListeners.forEach(([el, ...params]) => el.removeEventListener(...params));
    gEventListeners.forEach(params => Events.unlisten(...params));

    controlObjects.length = 0;
    domEventListeners.length = 0;
    gEventListeners.length = 0;
}

function isSlidePlaying() { return goId || mediaIsPlaying; }

function createGenThumbButton(helpersVisible, opts = {}) {
    let button = document.createElement('div');
    button.innerText = opts.name ? opts.name : 'Generate Thumbnail';

    let enabled = true;
    const setEnabled = (value) => {
        value = Boolean(value);
        if (value === enabled) return;
        enabled = value;

        if (value) {
            button.classList.remove('disabled');
        } else {
            button.classList.add('disabled');
        }
    };

    const waitForNextFrame = () => {
        return new Promise((resolve, reject) => {
            let callback = () => {
                Q3.Events.unlisten('post_render', callback);
                resolve();
            };

            Q3.Events.listen('post_render', callback);
        });
    };

    const generate = async () => {
        Q3.boundingBoxHelpers.forEach(h => h.visible = false);
        Q3.RenderManager.activeCamera.update = true;
        await waitForNextFrame();

        const viewCanvas = Q3.RenderManager.mainRenderer.domElement;
        const thumbCanvas = document.createElement('canvas');
        const { width: vWidth, height: vHeight } = viewCanvas;
        let { width, height } = SystemDefaults.getAssetViewSettings().thumbnail;
        if (opts.isFullHd) {
            width = 1920;
            height = 1080;
        }
        Object.assign(thumbCanvas, { width, height });
        const thumbCtx = thumbCanvas.getContext('2d');
        const scaleW = vWidth/width, scaleH = vHeight/height;
        const scaleMin = Math.min(scaleW, scaleH);
        const cropW = scaleMin*width, cropH = scaleMin*height;
        thumbCtx.drawImage(viewCanvas, (vWidth-cropW)*0.5, (vHeight-cropH)*0.5, cropW, cropH, 0, 0, width, height);

        if (helpersVisible()) {
            Q3.boundingBoxHelpers.forEach(h => h.visible = true);
        }
        Q3.RenderManager.activeCamera.update = true;

        if (opts.isSync) {
            thumbCanvas.toBlob(b => {
                let formData = new FormData();
                formData.append("thumbnail", b);
                formData.append("asset_type", '3D');
                formData.append("id", Utils.queryParams.get('variation_id'));

                $.ajax({
                    url: window.COOBO
                      ? "https://amp-api.embibe.com/assets/sync-variation-thumbnails"
                      : `http://${window.location.hostname}:1338/assets/sync-variation-thumbnails`,
                    type: 'POST',
                    dataType: "json",
                    contentType: false,
                    processData: false,
                    data: formData,
                    success: function() {
                        $('#asset-viewer-sync-thumb').text('Thumbnail synced');
                        $('#asset-viewer-sync-thumb').addClass('disabled')
                    },
                    error: (err) => {
                        $('#asset-viewer-sync-thumb').text('Thumbnail sync error')
                    }
                });
            });


        } else {
            const data = thumbCanvas.toDataURL();

            const link = document.createElement('a');
            link.setAttribute('href', data);
            link.setAttribute('download', 'Thumbnail.png');
            link.click();
        }

    };

    button.addEventListener('click', (event) => {
        if (!enabled) return;

        setEnabled(false);
        generate().finally(() => setEnabled(true));
    });

    return button;
}

export default addSlideControls;
export { addSlideControls, removeSlideControls, goToNextVisibleSlide, goToPrevVisibleSlide, goToSlide, playPauseClickHandler, stopAutoplay, isSlidePlaying, getNextVisibleSlideIndex };
